import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableRatings } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function Ratings({ profileData, internal }) {
  const t = useTranslations('common.profile.pages.community');
  const { loading, fetchData, loadMoreData } = useCache(
    `${profileData._id}_ratings`,
    `${config.apis.api.url}/rating/user/${profileData._id}`,
    {
      injectToken: true,
      invalidateWhen: ["NEW_RATING", `${profileData._id}_REFRESH`],
    }
  );
  const visibleRatings = filterRenderableRatings(fetchData?.data);

  if (loading) {
    return (
      <div className="profile-community-ratings-loader-container">
        <ProfileContentLoader />
      </div>
    );
  } else {
    return (
      <>
        {visibleRatings.length === 0 ? (
          <Text
            className="profile-community-ratings__empty-text font-size-medium"
            paragraph>
            {internal
              ? t('empty.ratings_internal')
              : t('empty.ratings_external')}
          </Text>
        ) : (
          <VirtualList items={fetchData} visibleItems={visibleRatings} onLoadMore={loadMoreData} />
        )}
      </>
    );
  }
}
